import React, { useRef } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { SEARCH_CATEGORY_LABELS } from '../../../../UniversalSearch.constants';
import {
  emptyStateContainerStyles,
  emptyStateShortcutKeyStyles,
  emptyStateShortcutLabelStyles,
  emptyStateShortcutRowStyles,
  emptyStateShortcutsSectionStyles,
} from '../../../../UniversalSearch.styles';
import { CategoryOrder } from '../../SearchResults.constants';
import CategoryHeader from '../CategoryHeader';
import RecentSection from '../RecentSection';

import { SHORTCUT_PREFIX } from './EmptyState.constants';
import SuggestedItem from './SuggestedItem';

const EmptyState = ({
  suggestedItems,
  flatSuggestedItems,
  selectedIndex,
  shortcutEntries,
  recentItems,
  onSelect,
  onHoverItem,
  onClearRecent,
}) => {
  const runningIndex = useRef(0);

  runningIndex.current = 0;

  return (
    <Box sx={emptyStateContainerStyles}>
      <RecentSection recentItems={recentItems} onClear={onClearRecent} onSelect={onSelect} />

      {CategoryOrder.map(category => {
        const items = suggestedItems[category];

        if (!items?.length) {
          return null;
        }

        return (
          <Box key={category}>
            <CategoryHeader label={SEARCH_CATEGORY_LABELS[category]} />
            {items.map(item => {
              const currentIndex = flatSuggestedItems.indexOf(item);
              const displayIndex = currentIndex >= 0 ? currentIndex : runningIndex.current;

              runningIndex.current += 1;

              return (
                <SuggestedItem
                  displayIndex={displayIndex}
                  item={item}
                  key={item.id}
                  selectedIndex={selectedIndex}
                  onHoverItem={onHoverItem}
                  onSelect={onSelect}
                />
              );
            })}
          </Box>
        );
      })}

      {!!shortcutEntries.length && (
        <Box sx={emptyStateShortcutsSectionStyles}>
          {shortcutEntries.map(({ key, tabName }) => (
            <Box key={key} sx={emptyStateShortcutRowStyles}>
              <Typography component="span" sx={emptyStateShortcutKeyStyles} variant="bold12">
                {`${SHORTCUT_PREFIX}${key}`}
              </Typography>
              <Typography sx={emptyStateShortcutLabelStyles} variant="regular12">
                {tabName}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  flatSuggestedItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  shortcutEntries: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      tabName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  suggestedItems: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  onClearRecent: PropTypes.func.isRequired,
  onHoverItem: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  recentItems: PropTypes.arrayOf(PropTypes.object),
};

export default EmptyState;
